module.exports = __webpack_public_path__ + "static/media/en_monalisa.99a2abd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rimages/en_monalisa.jpg
// module id = 76
// module chunks = 0